import login from './login';

export default {
  language: 'ru-RU',
  country: 'ru',
  name: 'Русский',
  embeddedLocale: login,
};
